module.exports = __webpack_public_path__ + "img/play3.95559018.png";